export const adminTheme = {
  token: {
    colorPrimary: '#0f766e',
    colorInfo: '#0f766e',
    colorSuccess: '#15803d',
    colorWarning: '#c2410c',
    colorError: '#b91c1c',
    colorBgBase: '#f5f7f4',
    colorTextBase: '#172426',
    colorBorderSecondary: '#d9e2dc',
    borderRadius: 14,
    borderRadiusLG: 20,
    fontFamily: '"Be Vietnam Pro", "Segoe UI", sans-serif',
  },
  components: {
    Layout: {
      headerBg: '#f5f7f4',
      siderBg: '#123b36',
      bodyBg: '#f5f7f4',
      triggerBg: '#123b36',
    },
    Menu: {
      darkItemBg: '#123b36',
      darkItemSelectedBg: '#1f5c54',
      darkItemHoverBg: '#184941',
      darkItemColor: 'rgba(255,255,255,0.82)',
      darkItemSelectedColor: '#ffffff',
      itemBorderRadius: 12,
    },
    Card: {
      borderRadiusLG: 20,
      headerBg: 'transparent',
    },
    Tabs: {
      itemSelectedColor: '#0f766e',
      itemColor: '#4b5563',
      inkBarColor: '#0f766e',
    },
  },
};
